// extracted by mini-css-extract-plugin
export var modal = "_f2-0";